<template>
    <div class="scope-written">
        <div class="box-shadow-small border-radius">
            <el-row type="flex" align="middle">
                <el-col :span="12">
                    <p class="mt-10">
                        <router-link to="/written"><i class="el-icon-arrow-left"></i>返回笔试列表</router-link>
                    </p>
                </el-col>
                <el-col :span="12">
                    <el-button type="warning" :plain="true" icon="el-icon-my-youjian color-warning" class="pull-right hide">
                        通知面试官
                    </el-button>
                </el-col>
            </el-row>
            <div class="table-list mt-20">
                <el-row class="text-center multi-setting">
                    <el-col :span="8" :offset="15">
                        <p class="label">评估人</p>
                        <div>
                            <search-down-list ref="topInterviewer" v-model="topObj.masterInterviewer"
                                         holder="评估人" style="width: 60%;display: inline-block;"></search-down-list>
                            <a href="javascript:;" class="betch-btn" @click="setBetchCol('masterInterviewer')"></a>
                        </div>
                    </el-col>
                </el-row>
                <el-form :model="dynamicForm" ref="ruleForm" class="demo-ruleForm mt-20">
                    <el-table :data="dynamicForm.lists" ref="recommendTable" @selection-change="selectionChange">
                        <el-table-column align="center" type="selection" width="50"></el-table-column>
                        <el-table-column
                                label="候选人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.phone }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="职位"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="笔试答卷"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="200">
                            <template slot-scope="scope">
                                {{ scope.row.examName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="评估人"
                                align="center"
                                min-width="220">
                            <template slot-scope="scope">
                                <el-form-item style="margin-top: 5px;">
                                    <search-down-list v-model="scope.row.markIds" :ref="`userSelects-${scope.row.id}`" :cacheOptions="scope.row.markList"></search-down-list>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="50">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeRow(scope.row.id, scope.$index)">移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <div class="text-center mt-20 mb-10">
                <el-button @click="cancelAndBack">取消</el-button>
                <el-button type="primary" :disabled="idsLength===0" @click="submitForm('ruleForm')">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import multiMixin from './multiMixin'
    import SearchDownList from 'components/userSelect/searchDownList'
    import formCommonMixin from 'mixins/formCommonMixin'
    import _ from 'underscore'

    export default {
        components: {SearchDownList},
        'mixins': [multiMixin, formCommonMixin],
        data () {
            return {
                ccUsers: [],
                selectedRow: [],
                watchRoute: false,
                topObj: {
                    masterInterviewer: ''
                }
            }
        },
        computed: {
            dynamicForm () {
                return {
                    lists: this.lists
                }
            },
            postData () {
                let data = this.lists.map(item => {
                    return _.pick(item, ['name', 'id', 'markIds'])
                })
                return data
            }
        },
        methods: {
            selectionChange (selections) {
                this.selectedRow = selections
            },
            saveForm (boolean) {
                let data = []
                let emptyCounter = 0
                this.postData.forEach(item => {
                    if (item.markIds) {
                        data.push(item)
                    } else {
                        emptyCounter++
                    }
                })
                if (emptyCounter === this.lists.length) {
                    this.$message({
                        type: 'warning',
                        message: '评估人不能为空'
                    })
                } else if (emptyCounter > 0) {
                    this.$confirm(`有${emptyCounter}条数据的评估人为空, 是否继续?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.update(data)
                    })
                } else {
                    this.update(data)
                }
            },
            update (data) {
                this.$axios.post('/arrangeExam/saveNewRecommend.api', {jsonArrStr: JSON.stringify(data)}, {'X-showMessage': true}).then(res => {
                    this.$router.replace({name: 'writtenList'})
                }).catch(console.error)
            },
            removeRow (id, index) {
                let caches = []
                this.lists.forEach(item => {
                    caches[item.id] = this.$refs[`userSelects-${item.id}`].getSelected()
                })
                let ids = this.lists.map(item => item.id)
                let curIndex = ids.indexOf(id)
                this.lists.splice(curIndex, 1)
                ids = this.lists.map(item => item.id)
                this.$nextTick(() => {
                    this.lists.forEach(item => {
                        var list = caches[item.id], idStr = list.map(item => item.id)
                        this.$refs[`userSelects-${item.id}`].setDefaultValue(list, idStr)
                    })
                })
                this.$router.replace({
                    name: this.$route.name,
                    params: {ids: ids.length ? ids.join(',') : -1}
                })
            },
            setBetchCol (attr) {
                let val = this.topObj[attr], names = ''
                if (attr === 'masterInterviewer') {
                    let list = this.$refs.topInterviewer.getSelected()
                    val = list.map(item => item.id).join(',')
                    names = list.map(item => item.name).join('，')
                }
                if (val === '') {
                    this.$message({
                        message: '数据不能为空',
                        type: 'warning'
                    })
                } else {
                    if (this.selectedRow.length === 0) {
                        this.$message({
                            message: '请勾选候选人',
                            type: 'warning'
                        })
                    } else {
                        let allIds = this.dynamicForm.lists.map(item => item.id)
                        this.selectedRow.forEach((item) => {
                            if (attr === 'masterInterviewer') {
                                this.$refs[`userSelects-${item.id}`].setDefaultValueLater(val, names)
                            }
                        })
                        console.log(this.$refs)
                    }
                }
            }
        },
        created () {
            this.fetchList('/arrangeExam/newRecommend.api')
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
    .scope-written{
        .multi-setting{
            border-top: 1px solid #ddd;
            margin-top: 15px;
            .label{
                font-weight: bold;
                margin: 5px;
            }
            .betch-btn{
                background: url("../arrangement/betch-btn.png") no-repeat center center;
                width: 40px;
                height: 36px;
                display: inline-block;
                vertical-align: bottom;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// writtenRecommend.vue?ef93d8ea